export const getRegisterLoading = state => state.auth.register.loading;
export const getOtpVerifyLoading = state => state.auth.register.verifyLoading;
export const getOtpRequestLoading = state =>
  state.auth.register.otpRequestLoading;
export const getOtpLastSentAt = state => state.auth.register.otpLastSentAt;
export const getRegisterValidationErrors = state => state.auth.register.error;
